const host="https://kash.in.ua/"
export default host